//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {email, minLength, required} from "vuelidate/lib/validators";
import {
  UserMixin,
  CmsMetaMixin,
  UserAuthMixin
} from "~/node_modules/sitis-nuxt/lib/mixins";
import UserProfile from "~/mixin/user-profile.js";
import Breadcrumbs from "~/components/page/PageBreadcrumbs";
import AuthTg from "~/components/additional-auth-methods/AuthTg.vue";

export default {
  name: "registration",
  components: {
    AuthTg,
    Breadcrumbs
  },

  data() {
    return {
      isShowPassword: false,
      isShowConfirmPassword: false,
      wasRegistration: false,
      isAgree: false,
      userAgreement: false,
      isLoading: false,
      telegramOrPhone: '',
      registrationForm: {
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
      },
    };
  },
  mixins: [
    UserMixin,
    UserProfile,
    UserAuthMixin,
    CmsMetaMixin
  ],

  validations: {
    registrationForm: {
      name: {required, minLength: minLength(2)},
      email: {required, email},
      password: {required, minLength: minLength(6)},
      confirmPassword: {required, minLength: minLength(6)},
    },
  },

  layout: "custom-layout",

  computed: {
    getBreadcrumbs() {
      const breadcrumbs = [
        {path: "/", title: this.$t("breadcrumbs.homePage")},
        {path: this.$route.path, title: this.$t('registration.title')},
      ];
      return breadcrumbs;
    },
    isRecaptchaTest() {
      return Boolean(Number.parseFloat(this.$store?.state?.appState?.config?.useReCaptchaForAuth || 0))
    },

    isUseGoBack: function () {
      if (!process.client) {
        return false
      }
      return Boolean(window.history?.length > 2)
      // return Boolean(
      //   window.history?.length > 2 &&
      //   this.$route?.query?.goback
      // )
    },
    isShowAuthTg: function () {
      return this.$route?.query?.authTg === "1"
    }
  },

  mounted: function () {
    const posTop = document.getElementById('scroll-container');
    posTop.scrollTo({top: 0, behavior: "smooth"});

    const refCode = this.$route?.query?.r || "";
    if (!!refCode) {
      this.$cookies.set("r", refCode, {
        path: "/",
        expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1))
      });
    }
  },

  methods: {
    async onSubmitForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      }

      if (this.registrationForm.password !== this.registrationForm.confirmPassword) {
        this.$toast.error(this.$t("registration.passwordsMismatchMessage"));
        return null;
      }

      if (this.telegramOrPhone) {
        this.$cookies.set('telegram_or_phone', this.telegramOrPhone, {
          path: "/",
          expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
        })
      }

      if (this.$nuxt.context.env?.authorizeUserAfterRegistration === '1' || this.$nuxt.context.env?.authorizeUserAfterRegistration === 1) {
        await this.registrationAfterUser();
        return
      }

      this.isLoading = true;
      let newForm = {...this.registrationForm};

      delete newForm.confirmPassword;

      // this.$yandexMetrika.reachGoal("register");
      if (Boolean(typeof ym !== "undefined")) {
        ym(86626883, "reachGoal", "register");
      }

      if (this.isRecaptchaTest) {
        newForm['g-recaptcha-response'] = await this.$recaptcha.getResponse().then((res) => {
          return res
        }).catch(() => {
          return ""
        });
        await this.$recaptcha.reset();
      }

      try {
        let res = await this.$api.agent.transport.post("users/signup", newForm);
        if (res) {
          this.wasRegistration = true;
          this.registrationForm = {
            email: "",
            password: "",
            name: "",
            confirmPassword: "",
          };

          this.$nextTick(() => {
            this.$v.$reset();
          });
          this.isAgree = false;
        }
        if (this.isUseGoBack) {
          this.$router.back();
        }
      } catch (error) {
        let errMessage = error?.response?.data?.[0].message || "Server Error";
        this.$toast.error(errMessage, {});
      }
      this.isLoading = false;
    },


    registrationAfterUser: async function () {
      this.isLoading = true;

      // Подготовка тела формы для отправки
      const formBody = {...this.registrationForm};
      delete formBody.confirmPassword;
      if (this.isRecaptchaTest) {
        formBody['g-recaptcha-response'] = await this.$recaptcha.getResponse().then((res) => {
          return res
        }).catch(() => {
          return ""
        });
        await this.$recaptcha.reset();
      }

      // Процес регистрации пользователя
      const responseCreateUser = await this.$api.agent.transport.post("/users/signup", {
        ...formBody
      }).then((res) => {
        return res.data
      }).catch((err) => {
        const errorData = err?.response?.data;
        let errorMessage = [];
        if (Array.isArray(errorData) && errorData.length) {
          errorMessage = errorData.map((t) => t.message)
        }
        if (!errorMessage.length) {
          errorMessage.push(this.$t('errors.err1'))
        }

        return {
          error: errorMessage.join(";<br/>")
        }
      });
      if (responseCreateUser.error) {
        this.isLoading = false;
        this.$toast.error(responseCreateUser.error);
        return
      }

      // Процес авторизации пользователя
      const responseLoginUser = await this.$api.agent.transport.post("/users/login", {
        username: formBody.email,
        password: formBody.password,
        "g-recaptcha-response": formBody['g-recaptcha-response'] || ""
      }).then((res) => {
        return res.data
      }).catch((err) => {
        const errorData = err?.response?.data;
        let errorMessage = [];
        if (Array.isArray(errorData) && errorData.length) {
          errorMessage = errorData.map((t) => t.message)
        }
        if (!errorMessage.length) {
          errorMessage.push(this.$t('errors.err1'))
        }

        return {
          error: errorMessage.join(";<br/>")
        }
      })
      if (responseLoginUser.error) {
        this.isLoading = false;
        this.$toast.error(responseCreateUser.error);
        return
      }

      if (Boolean(typeof ym !== "undefined")) {
        ym(86626883, "reachGoal", "register");
      }

      this.setToken({authToken: responseLoginUser.token});
      this.$cookies.set("authToken", responseLoginUser.token, {
        path: "/",
        expires: new Date(new Date().setFullYear(new Date().getFullYear() + 5)),
      });
      await this.getUser();
      this.isLoading = false;
      if (this.isUseGoBack) {
        this.$router.back();
      } else {
        this.$router.replace(this.localePath("/profile"));
      }
    },
  },
};
